<template>
    <div v-if="software">
      
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B1.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 硬件产品 -->
                         {{  $t("hardware.hardware_products") }}
                    </h1>
                    <h3>
                        <!-- 通过数字化联网改造、升级的方式，采集设备实时的生产焊接数据，实时掌握设备运行状态、设备利用率、焊工焊接效率、资源消耗（焊材、保护气体、电能）等情况，通过实时的焊接数据与工艺要求对比，掌控焊接质量。 -->
                     {{  $t("hardware.hardware_products_text") }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'mb_home' }">
                             {{  $t("header.home") }}
                            <!-- 首页 -->
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: 'mbProduct', query: {type: 'hardware'} }">
                            <!-- 硬件产品 -->
                            {{  $t("hardware.hardware_products") }}
                        </el-breadcrumb-item>
						<el-breadcrumb-item>
                            <!-- {{ software.title_zh || "" }} -->
                        {{  $t(`hardware.${software.i18n_title_zh}`) }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      
		<section class="blog-details">
			<div class="container">
				<div class="row">
					<div style="width: 100%">
                        <div class="row_tit">
                            <!-- {{ software.title }} -->
                            {{  $t(`hardware.${software.i18n_title}`) }}
                        </div>
                        <img :src="software.pictureUrl" class="row_prroimg">
                        <div class="row_con">
                            <!-- v-html="item" -->
                            <p style="text-indent:2em; font-size: 16px" v-for="(item, index) in software.i18n_contentList" :key="index" v-html="translateHtml(item)">
                                
                            </p>
                        </div>
                        <!-- 技术参数 -->
                        <div class="col-xl-12 col-lg-12" v-if="software.i18n_tableList.length" style="margin-top: 30px;">
                            <table class="table_row" style=" width: 100%; margin: 0 auto; " cellspacing="0" cellpadding="0" border="1">
                                <tr class="tr_row"> 
                                    <td class="td_row" colspan='3' style="font-weight: bold; font-size: 14px" >
                                        <!-- {{ software.tableTitle }} -->
                                        {{  $t(`hardware.${software.tableTitle}`) }}
                                    </td>
                                </tr>
                                <tr class="tr_row" v-for="(item,index) in software.i18n_tableList" :key="index"> 
                                        <td class="td_row" style="width: 30%;" :class="index == 0 ? 'td_bold': ''">
                                            <!-- {{ item.tb1 }} -->
                                            {{ getTb(item.tb1) }}
                                        </td>
                                        <td class="td_row" style="width: 40%;" :class="index == 0 ? 'td_bold': ''">
                                            <!-- {{ item.tb2 }} -->
                                            {{ getTb(item.tb2) }}
                                        </td>
                                        <td v-if="software.tdShow" class="td_row" style="width: 30%;" :class="index == 0 ? 'td_bold': ''">
                                            <!-- {{ item.tb3 }} -->
                                            {{ getTb(item.tb3) }}
                                        </td>
                                </tr>
                            </table>
                        </div>
                        <!-- 产品功能对照表 -->
                        <div class="col-xl-12 col-lg-12" v-if="software.illustrateUrl">
                            <div>
                                <p style='font-weight: bold; margin: 30px 0; '>
                                    <!-- {{ software.illustrateTitle }}  -->
                                    {{$t(`hardware.${software.i18n_illustrateTitle}`) }}
                                </p>
                            </div>
                            <div>
                                <img style=" max-width: 100%;" :src="software.illustrateUrl" />
                            </div>
                        </div>
					</div>
				</div>
			</div>
		</section>

    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbHardware',
      mixins: [MixinsList],
    components: { },
    data () {
        return {          
            software: null
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {    },
    methods: {
        // 获取内容
        async getList() {
            // const { result } = res
            try {
                const {hardware} = await loadData('productHardware', this.lang)
                
                this.software = hardware[this.$route.query.type]
            } catch (error) {
                console.error('[mbhardware] 加载失败:', error)
                this.software = {}
            }
        },

         translateHtml(htmlString) {
             if (!htmlString) return '';
            let key = 'hardware.'+htmlString
            let translated = this.$t(key)
            return translated;
        },
        getTb(itemTb) {
             if (!itemTb) return '';
            const key = itemTb.includes('hardware_') ? `hardware.${itemTb}` : itemTb;
            return this.$t(key);
        }
     
    }
}
</script>
<style scoped>
body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: transparent;  
}


.blog-details {
    padding: 60px 0 120px;
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}

.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3{
    /* width: 50%; */
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }
.row_tit {
    clear: both;
    font-size: var(--font-size-20);
    font-weight: bold;
    color: var(--notech-base);
    line-height: 22px;
    padding: 0px 0px 15px 0px;
    text-align: center;
    margin-bottom: 15px;
}
.row_date {
    line-height: 15px;
    margin-bottom: 15px;
    color: #999;
    font-size: var(--font-size-16);
    text-align: center;
}
.row_prroimg {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    max-height: 600px;
    margin-bottom: 10px;
}

.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}

.tr_row {
    height: 40px;
    border-width: 1px;
}
.td_row  {
    font-size: 14px;
    text-align: center;
    border-width: 1px;
}
.td_bold {
    font-weight: bold;
}
</style> 
